var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightChervon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.455749 2.12564L9.29727 11.091L0.45575 20.0563C0.297462 20.2165 0.208846 20.4315 0.208846 20.6554C0.208846 20.8793 0.297462 21.0944 0.45575 21.2545C0.532631 21.3321 0.624395 21.3937 0.72567 21.4358C0.826945 21.4778 0.935694 21.4995 1.04555 21.4995C1.1554 21.4995 1.26415 21.4778 1.36542 21.4358C1.4667 21.3937 1.55846 21.3321 1.63534 21.2545L11.0431 11.717C11.2082 11.5495 11.3007 11.3249 11.3007 11.091C11.3007 10.8571 11.2082 10.6324 11.0431 10.4649L1.63716 0.927391C1.56022 0.849285 1.46823 0.787203 1.36662 0.744814C1.26501 0.702425 1.15584 0.680586 1.04555 0.680586C0.935256 0.680586 0.826083 0.702425 0.724472 0.744814C0.622862 0.787203 0.530872 0.849285 0.453933 0.927391C0.295646 1.08757 0.20703 1.3026 0.20703 1.52652C0.20703 1.75043 0.295646 1.96546 0.453933 2.12564L0.455749 2.12564Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightChervon);
export default __webpack_public_path__ + "static/media/RightChervon.a41172be84af8037bc946b21cf10285d.svg";
export { ForwardRef as ReactComponent };